import {InjectionToken} from '@angular/core';

export const WEBAI_STUDIO_BASE_URL = new InjectionToken<string>("Base URL for WebAI Studio");
